import type { Shock } from './scenario'

/**
 * Version 2 of scenarios, not built yet: shocks proposed by outside data
 * instead of typed in. Each source turns what it watches into suggested
 * shocks in the same `Shock` shape the scenario maths already takes, so
 * adding one is this interface and nothing else.
 *
 * Intended sources, each with its own licence and data-quality check before
 * it is switched on:
 *   - crop yields and production (FAO, which the API already loads; lagged
 *     about two years, so trends rather than crises);
 *   - crop-monitoring bulletins (e.g. the EU JRC's, USDA's), closer to real time;
 *   - export restrictions and bans (e.g. IFPRI's tracker, trade-flow data);
 *   - fishing seasons and quotas (a cancelled season stops fishmeal at once).
 *
 * The API side mirrors this: GET /scenario/signals, backed by providers in
 * eudr-api's services/signals.ts (empty today). `apiSignals` reads it.
 */

export interface Signal {
  id: string
  providerId: string
  title: string
  detail: string
  observedAt: string
  sourceUrl?: string
  suggestedShock: Omit<Shock, 'id' | 'source'>
}

export interface SignalSource {
  id: string
  label: string
  fetch(): Promise<Signal[]>
}

/** Sources the scenario screen asks for suggestions. None yet: the panel stays hidden while this is empty. */
export const SIGNAL_SOURCES: SignalSource[] = []

/** A suggestion, as a shock the scenario can apply. */
export const shockFrom = (s: Signal): Shock => ({ ...s.suggestedShock, id: `signal-${s.id}`, source: s.providerId, label: s.title })
